export class AddEventBriteGeneralFeedCommand {
    constructor(public name: string,
                public title: string,
                public tags = 'Visitor Posts',
                public hubName: string,
                public moderate = true,
                public type = 'general',
                public socialName = 'eventbrite') {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/hub/event/add.eventbrite.general.feed.command.ts